import * as React from 'react';
import { MobXProviderContext } from 'mobx-react';
import { AnalyticsStore, ContextStore, RouteStore, PageStore } from 'bernie-core';
import {
  AdvertisingStore,
  SearchCriteriaStore,
  ListingsStore,
  SearchFormStore,
  SortFilterStore,
  ErrorStore,
  DialogsStore,
  PageTitleStore,
  ClientMetadataStore,
  FreeCancellationStore,
  FlightInformationStore,
  InformationCriteriaStore,
  MessagingCardsStore,
  BannersStore,
  PriceSummaryStore,
  PoliciesStore,
  FlexibleSearchResultsStore,
  SearchResultsStore,
  FlightsSelectedJourneyReviewStore,
  CheapestListingInfoStore,
  DynamicElementsStore,
  GaiaIdStore,
  StepIndicatorStore,
  OpinionLabStore
} from 'stores';

interface FlightsStoresType {
  context: ContextStore;
  routeStore: RouteStore;
  advertisingStore: AdvertisingStore;
  searchCriteriaStore: SearchCriteriaStore;
  searchResults: SearchResultsStore;
  analytics: AnalyticsStore;
  listingsStore: ListingsStore;
  searchFormStore: SearchFormStore;
  sortFilterStore: SortFilterStore;
  errorStore: ErrorStore;
  dialogsStore: DialogsStore;
  pageTitleStore: PageTitleStore;
  opinionLabStore: OpinionLabStore;
  clientMetadataStore: ClientMetadataStore;
  page: PageStore;
  flightInformationStore: FlightInformationStore;
  informationCriteriaStore: InformationCriteriaStore;
  freeCancellationStore: FreeCancellationStore;
  messagingCardsStore: MessagingCardsStore;
  bannersStore: BannersStore;
  priceSummaryStore: PriceSummaryStore;
  policiesStore: PoliciesStore;
  flexibleSearchResultsStore: FlexibleSearchResultsStore;
  flightsSelectedJourneyReviewStore: FlightsSelectedJourneyReviewStore;
  cheapestListingInfoStore: CheapestListingInfoStore;
  dynamicElementsStore: DynamicElementsStore;
  gaiaIdStore: GaiaIdStore;
  stepIndicatorStore: StepIndicatorStore;
}

export const useStores = (): FlightsStoresType => React.useContext(MobXProviderContext);
